import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MenuItem, TextField } from "@mui/material"
import React from "react"
import { ISelectButtonItem } from "ui/model"
import { addImportant } from "ui/tools/common"
import { FlexBox } from "./FlexBox"

interface ISelectButtonProps {
  id: string
  title: string
  items: ISelectButtonItem[]
  icon: IconDefinition
  sx?: any
}

export const SelectButton = React.memo(({ id, title, icon, items, sx }: ISelectButtonProps): JSX.Element => {
  const [selectedIndex, setSelectedIndex] = React.useState(0)
  const selectedItem = items[selectedIndex]
  return (
    <FlexBox
      sx={{
        "& div > fieldset.MuiOutlinedInput-notchedOutline": {
          borderRight: addImportant("none"),
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0
        }
      }}>
      <TextField
        id={`${id}-select-field`}
        variant="outlined"
        disabled={items.find(i => !i.disabled) === undefined}
        select
        fullWidth
        sx={{ ...sx }}
        size="small"
        label={title}
        value={selectedIndex}
        onChange={event => setSelectedIndex(Number(event.target.value))}
        required>
        {items.map((i, index) => (
          <MenuItem key={index} id={i.id} value={index} disabled={i.disabled}>
            {i.label}
          </MenuItem>
        ))}
      </TextField>
      <FlexBox
        id={`${id}-button`}
        className={selectedItem.disabled ? "disabled Mui-disabled" : "actif"}
        onClick={() => {
          if (!selectedItem || selectedItem.disabled) {
            return
          }
          selectedItem.onClick()
        }}
        sx={{
          "cursor": selectedItem.disabled ? "" : "pointer",
          "minHeight": "2.49rem",
          "minWidth": "2.6rem",
          "border": theme => theme.palette.border,
          "borderRadius": 0,
          "borderTopRightRadius": ".25rem",
          "borderBottomRightRadius": ".25rem",
          "color": theme => theme.palette.specialText,
          "backgroundColor": theme => theme.palette.primary.main,
          "&.actif:hover": {
            color: theme => theme.palette.primary.main,
            backgroundColor: theme => theme.palette.specialText,
            borderColor: theme => theme.palette.primary.main
          },
          "&.disabled": {
            filter: "grayscale(1)"
          }
        }}>
        <FontAwesomeIcon icon={icon} size="1x" className="icon" />
      </FlexBox>
    </FlexBox>
  )
})
